import React from "react";

import MetaMaskOnboarding from "@metamask/onboarding";
import { useWeb3React } from "@web3-react/core";
import WebFlow from "./Webflow";
import AppContract from "./ABI.json";
import { Injected } from ".";
import { BigNumber, ethers } from "ethers";
import { toast } from "react-toastify";
import {
  APP_TOKEN_ADDRESS,
  DEFAULT_CHAIN,
} from "./constant";


const App = () => {
  // const APP_TOKEN_ADDRESS = "0x5497f0176ba54585f8eb620e5d2fcab0f547945f";
  // const DEFAULT_CHAIN = "0x4";
  const onBoarding = React.useRef();
  const hasMetaMaskOrWeb3Available =
    MetaMaskOnboarding.isMetaMaskInstalled() ||
    window.ethereum ||
    window.web3;

  const { error, active, activate, library, chainId } = useWeb3React();
  const [data, setData] = React.useState();

  const price = BigNumber.from("33000000000000000");
  React.useEffect(() => {
    onBoarding.current = new MetaMaskOnboarding();
  }, []);

  const swtichChain = async (_chainId) => {
    if (`0x${_chainId}` !== DEFAULT_CHAIN) {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: DEFAULT_CHAIN }],
      });
    }
  };

  React.useEffect(() => {
    swtichChain(chainId);
  }, [chainId]);

  React.useEffect(() => {
    if (active || error) {
      onBoarding.current?.stopOnboarding();
    }
  }, [active, error]);

  const loadData = async () => {
    if (library && active) {
      await swtichChain(chainId);
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(
          APP_TOKEN_ADDRESS,
          AppContract,
          signer
        );

        const _publicSupply = await contract.PUBLIC_SUPPLY(); //max
        const publicSupply = _publicSupply.toNumber();
        const _totalPublicSupply = await contract.totalPublicSupply(); //current
        const totalPublicSupply = _totalPublicSupply.toNumber();
        const leftQuantity = publicSupply - totalPublicSupply;

        setData({ leftQuantity });
      } catch (err) {
        setData(undefined);
      }
    } else {
      setData(undefined);
    }
  };

  React.useEffect(() => {
    if (active) {
      loadData();
    }
    // eslint-disable-next-line
  }, [active, library]);

  const handlerInstallClick = () => {
    onBoarding.current?.startOnboarding();
  };

  const onConnect = () => {
    if (!hasMetaMaskOrWeb3Available) {
      handlerInstallClick();
      return;
    }
    if (!active) {
      activate(Injected, undefined, true);
    }
  };

  const getBtnText = () => {
    if (!hasMetaMaskOrWeb3Available) {
      return "Install Metamask";
    }
    if (!active) {
      return "Connect Wallet";
    }
  };

  const parseError = (obj) => {
    let err;
    if (typeof obj === "object") {
      if (obj.code === 4001) {
        toast.error(obj.message);
      } else if (obj.code) {
        toast.error(obj.error.message);
      } else {
        toast.error("Something went wrong.");
      }

      err = obj;
    } else {
      toast.error(obj);
      err = obj;
    }
    console.error("err -> ", err);
  };

  const onMintFree = async () => {
    if (library && active) {
      await swtichChain(chainId);
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(
          APP_TOKEN_ADDRESS,
          AppContract,
          signer
        );
        const tx = await contract.mintFree();
        await toast.promise(provider.waitForTransaction(tx.hash), {
          pending: "Pending transaction...",
          success: "Your transaction has been queued, please check your wallet.",
          error: "Oops! Something went wrong",
        });
      } catch (err) {
        parseError(err);
        throw err;
      }
    }
  };

  const onMint = async (quantity) => {
    if (library && active) {
      await swtichChain(chainId);

      const txValue = BigNumber.from(quantity).mul(price);
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(
          APP_TOKEN_ADDRESS,
          AppContract,
          signer
        );
        const tx = await contract.mint(quantity, {
          value: txValue.toString(),
        });
        await toast.promise(provider.waitForTransaction(tx.hash), {
          pending: "Pending transaction...",
          success: "Your transaction has been queued, please check your wallet.",
          error: "Oops! Something went wrong",
        });
      } catch (err) {
        parseError(err);
        throw err;
      }
    }
  };

  return (
    <WebFlow
      key={"mint"}
      onConnect={onConnect}
      text={getBtnText()}
      connected={active}
      onMint={onMint}
      onMintFree={onMintFree}
      leftQuantity={data?.leftQuantity}
      price={price}
    />
  );
};

export default App;
